<div class="period-popup session-idle-warning-dialog" *ngIf="state$ | async as state">
    <div class="popup-header">
        <h1>{{ 'sessionLifecycle.warningTitle' | translate }}</h1>
    </div>

    <mat-dialog-content>
        <div class="popup-body session-idle-warning-dialog__body">
            <p>
                {{
                    'sessionLifecycle.warningText' | translate : { seconds: state.remainingSeconds }
                }}
            </p>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="start" class="contract-popup-buttons">
        <div class="action-bottom-buttons">
            <button
                (click)="stayInSystem()"
                [disabled]="isPinging$ | async"
                class="btn green"
                type="button"
            >
                {{ 'sessionLifecycle.stayInSystem' | translate }}
            </button>
        </div>
    </mat-dialog-actions>
</div>
